import { render, staticRenderFns } from "./ListShopify.vue?vue&type=template&id=2ff0ed44"
import script from "./ListShopify.vue?vue&type=script&lang=js"
export * from "./ListShopify.vue?vue&type=script&lang=js"
import style0 from "./ListShopify.vue?vue&type=style&index=0&id=2ff0ed44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports